// Mock data for Kyle D. Gobel, Attorney at Law
// NOTE: All data here is MOCKED for the frontend-only teaser.

export const firm = {
  name: "Kyle D. Gobel",
  title: "Attorney at Law",
  tagline: "Trusted counsel in Crawfordsville, Indiana",
  phone: "765.364.1914",
  phoneHref: "tel:7653641914",
  address: "134 W. Main St.",
  city: "Crawfordsville, IN 47933",
  hours: "8 a.m. – 12 p.m. & 1 – 4 p.m.",
  email: "office@justice-law.com",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Practice Areas", href: "#practice" },
  { label: "Biography", href: "#biography" },
  { label: "Contact", href: "#contact" },
];

export const heroImage =
  "https://images.unsplash.com/photo-1636652966850-5ac4d02370e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjb3VydGhvdXNlJTIwanVzdGljZXxlbnwwfHx8fDE3ODczNjQ2ODV8MA&ixlib=rb-4.1.0&q=85";

export const portraitImage =
  "https://customer-assets-v7afamib.emergentagent.net/job_legal-ui-refresh-3/artifacts/q26ervcj_KDG-1024x1536.jpg";

export const officeImage =
  "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxsYXclMjBvZmZpY2V8ZW58MHx8fHwxNzg3MzY0Njg1fDA&ixlib=rb-4.1.0&q=85";

export const practiceAreas = [
  {
    title: "Criminal Law",
    icon: "Gavel",
    desc: "Defense from misdemeanor matters to high-level felony cases, including jury trials.",
  },
  {
    title: "Family Law",
    icon: "Users",
    desc: "Compassionate guidance through divorce, custody, and domestic relations matters.",
  },
  {
    title: "Mediation",
    icon: "Handshake",
    desc: "Registered Domestic Relations Mediator helping parties reach fair resolutions.",
  },
  {
    title: "Expungements",
    icon: "FileX",
    desc: "Clearing eligible records to give you a genuine fresh start.",
  },
  {
    title: "Specialized Driving Privileges",
    icon: "Car",
    desc: "Restoring your ability to drive legally after a suspension.",
  },
  {
    title: "General Litigation",
    icon: "Scale",
    desc: "Skilled civil litigation representation from filing through trial.",
  },
  {
    title: "Juvenile Delinquency",
    icon: "Shield",
    desc: "Protecting the rights and futures of young clients and their families.",
  },
  {
    title: "Guardian Ad Litem",
    icon: "HeartHandshake",
    desc: "Registered Guardian ad Litem advocating for the best interests of children.",
  },
];

export const biographyParagraphs = [
  "Kyle D. Gobel is a Crawfordsville native and a 2002 graduate of Crawfordsville High School. In 2006, Kyle graduated with honors from Hanover College. In 2010, Kyle earned his law degree from Indiana University Robert H. McKinney School of Law, where he graduated with honors and served as an Articles Editor of the Indiana Law Review. During law school, Kyle worked as a law clerk for Rubin & Levin, P.C., a business law firm in Indianapolis.",
  "After graduating law school, Kyle joined the Montgomery County Prosecutor’s Office, where he worked as a deputy prosecutor for three years. Kyle then moved into private practice, working as an associate attorney at Richard D. Martin & Associates in Frankfort, Indiana. Kyle became a partner at Collier Gobel Homann in 2017 and a partner at Gobel Justice & Pyle in 2022.",
  "Kyle has extensive experience in family law, criminal defense, and civil litigation. He has represented criminal defendants in cases ranging from misdemeanor matters to high-level felony cases, including several jury trials. He is also a registered Domestic Relations Mediator and a registered Guardian ad Litem.",
  "Kyle is currently a member of the West Central Regional Community Corrections board.",
  "Kyle and his wife Erin reside in Crawfordsville and have a twelve-year-old daughter.",
];

export const credentials = [
  { value: "2010", label: "J.D., IU McKinney School of Law" },
  { value: "15+", label: "Years of Legal Experience" },
  { value: "3", label: "Years as Deputy Prosecutor" },
  { value: "Partner", label: "Gobel Justice & Pyle, since 2022" },
];

export const education = [
  { year: "2002", title: "Crawfordsville High School", detail: "Graduate, Crawfordsville native" },
  { year: "2006", title: "Hanover College", detail: "Graduated with honors" },
  { year: "2010", title: "IU McKinney School of Law", detail: "J.D. with honors · Articles Editor, Indiana Law Review" },
  { year: "2017", title: "Collier Gobel Homann", detail: "Became Partner" },
  { year: "2022", title: "Gobel Justice & Pyle", detail: "Became Partner" },
];
